module.exports = __webpack_public_path__ + "img/pdf.abebae14.svg";